import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check, Loader2, Mail, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function BookingReceived() {
  const [sp] = useSearchParams();
  const bookingId = sp.get("booking_id");
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bookingId) { setLoading(false); return; }
    (async () => {
      try {
        const { data } = await api.get(`/bookings/${bookingId}`);
        setBooking(data);
      } catch (e) {
        console.error("booking fetch failed", e);
      }
      finally { setLoading(false); }
    })();
  }, [bookingId]);

  if (loading) return (
    <div className="section flex justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-pebble" />
    </div>
  );

  return (
    <div className="section">
      <div className="mx-auto max-w-2xl">
        <div className="text-center">
          <div className="h-14 w-14 mx-auto rounded-full bg-champagne flex items-center justify-center">
            <Check className="h-7 w-7 text-charcoal" />
          </div>
          <div className="overline mt-6">Request received</div>
          <h1 className="h-display mt-3 text-4xl md:text-5xl">Thank you — we're on it.</h1>
          <p className="mt-5 text-graphite max-w-xl mx-auto leading-relaxed">
            Our team just received your booking request and will review your event details shortly. You'll hear from us within 24 hours with availability confirmation and a final quote.
          </p>
        </div>

        {booking && (
          <div className="mt-10 card-soft p-6 md:p-8 text-left">
            <div className="overline">Reservation Request</div>
            <div className="h-display text-2xl mt-1">#{booking.id.slice(0,8).toUpperCase()}</div>
            <div className="mt-4 grid sm:grid-cols-2 gap-4 text-sm">
              <div><span className="text-graphite">Event:</span> {booking.event_type} · {booking.event_date}</div>
              <div><span className="text-graphite">Location:</span> {booking.event_city}</div>
              <div><span className="text-graphite">Guests:</span> {booking.guest_count}</div>
              <div><span className="text-graphite">Trailers requested:</span> {booking.trailers_requested === 2 ? "Two (6 stalls)" : booking.trailers_requested === 1 ? "One (3 stalls)" : "Undecided"}</div>
            </div>
            <Link to={`/portal/${booking.id}`} data-testid="portal-link" className="btn-primary mt-6 w-full">View your request</Link>
          </div>
        )}

        <div className="mt-10 card-soft p-6 text-center">
          <div className="overline">Need to reach us sooner?</div>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-4">
            <a href="mailto:info@southernutaheventrentals.com" className="inline-flex items-center gap-2 text-sm text-charcoal hover:text-pebble transition-colors">
              <Mail className="h-4 w-4" /> info@southernutaheventrentals.com
            </a>
            <a href="tel:+14352889909" className="inline-flex items-center gap-2 text-sm text-charcoal hover:text-pebble transition-colors">
              <Phone className="h-4 w-4" /> (435) 288-9909
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
